/**
 * Toolbar - Preview pane of the toolbar
 *  Contains the web/mobile preview functions.
 *
 * @depends jquery.js
 * @depends extendClass.js
 *
 */
/*global Klazz, diy, jimdoData, jQuery, systemurl, script_basisID, stagingMode */
var $ = require('jquery');

var Preview, initEditView, initWebView, initMobilePreview,
    initEditViewInMobilePreview, initWebViewInMobilePreview;

initEditView = function (targetElement) {
    var pageId;

    // try to get the page id from several places - this is needed until all page caches expire //
    pageId = $('body').attr('data-pageid');
    if (!pageId) {
        pageId = jimdoData.pageId;
    }
    if (pageId) {
        targetElement.attr('href', systemurl + 'app/' + script_basisID + '/' + pageId + '/');
    } else {
        targetElement.attr('href', systemurl + 'app/' + script_basisID + '/');
    }
};
initWebView = function (targetElement) {
    targetElement.attr('href', systemurl + 'app/default/index/gotoviewmode/websiteId/' +
        script_basisID + '/pageId/' + $('body').attr('data-pageid'));
};
initMobilePreview = function(targetElement) {
    targetElement.attr('href', systemurl + 'app/default/index/gotomobileview/websiteId/' +
        script_basisID + '/pageId/' + $('body').attr('data-pageid')
    );
};
initEditViewInMobilePreview = function (targetElement) {
    targetElement.attr('href', window.backLinkUrl);
};
initWebViewInMobilePreview = function(targetElement) {
    targetElement.attr('href', window.previewPageUrl);
};

Preview = Klazz.extend({
    contextType: '', /* possible values: editor, web */
    toolbar: null,
    options: {
        classSelected : 'selected'
    },
    messages: {
        viewLabel : '',
        backToEditingLabel: '',
        tooltipWebView: '',
        tooltipMobileView: ''
    },
    element: null,
    setup: function(){
        this.contextType = diy.context.type;
        this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbar); // note: we break object reference
        this.options = $.extend(true, {}, this.options); // note: we break object reference
        this.messages.backToEditingLabel = jimdoData.messages.back;
    },
    initialize: function(toolbar) {
        this.toolbar = toolbar;
        this.setup();
        this.draw();
    },
    draw: function(){
        var elementHtml,
            self = this,
            isTouchDevice = Modernizr.touch;

        // build buttons HTML //
        elementHtml = '<div id="previewContainer" >';

        elementHtml += '<a class="label viewLabel" style="display: none;">' + this.messages.viewLabel + '</a> ';
        elementHtml += '<a class="label backLabel" style="display: none;">' + this.messages.backToEditingLabel + '</a> ';

        elementHtml += '<a class="webView ' + (this.contextType === 'web' ? this.options.classSelected : '') + '"><div class="icon" title="'+ this.messages.tooltipWebView +'"></div></a> ';

        /* if mobile preview is enabled, add the button to the toolbar */
        elementHtml += '<div class="mobile-preview-button-container">';
            elementHtml += '<div class="mobile-preview-button-container">' +
                '<a class="mobileView"><div class="icon" title="'+ this.messages.tooltipMobileView +'"></div></a> ';
        elementHtml += '</div></div>';

        if (this.contextType === 'editor') {
            elementHtml += '<div class="spacer"><div class="icon"></div></div>';
        }

        elementHtml += '</div>';

        this.element = this.toolbar.pushToPanel('left', elementHtml);

        if (!isTouchDevice) {
            if (this.contextType === 'editor') {
                this.element.find('.viewLabel').show();
            } else if (this.contextType === 'web') {
                this.element.find('.backLabel').show();
            }
        }

        if (this.contextType === 'editor') {
            this.showMobilePreviewStartButton();
        }

        if (this.contextType === 'editor') {
            initWebView(this.element.find('.webView'));
            initMobilePreview(this.element.find('.mobileView'));
        } else if (this.contextType === 'web') {
            initEditView(this.element.find('.webView'));
            initEditView(this.element.find('.backLabel'));
        } else if (this.contextType === 'mobilepreview') {
            initEditViewInMobilePreview(this.element.find('.backLabel'));
            initWebViewInMobilePreview(this.element.find('.webView'));
            initEditViewInMobilePreview(this.element.find('.mobileView'));
        }

        if (this.contextType === 'web') {
            this.element.find('.mobileView').click(function() {
                var currentState = self.isMobilePreviewStateActive();
                if (currentState) {
                    diy.editor.mobilepreview.close();
                } else {
                    diy.editor.mobilepreview.open();
                }
                self.setMobilePreviewStateActive(!currentState);
            });
        }
    },
    showMobilePreviewStartButton: function() {
        this.element.find('.mobile-preview-button-container').show();
    },
    setMobilePreviewStateActive: function(b) {
        var $previewContainer = $('#previewContainer'),
            hideElList,
            isTouchDevice = Modernizr.touch;
        $previewContainer.find('.mobileView')[b ? 'addClass' : 'removeClass']('selected');

        // HACK: list of elemeents that are not displayed in mobile preview
        // Each element should say if it's displayable or not, but for now
        // we keep this list here
        hideElList = [
            '.undo-redo-widget',
            '.maintenanceModeContainer',
            '#previewContainer .spacer:first',
            '.helpSearchContainer',
            '.helpContainer + .spacer',
            '.helpContainer',
            '#administrationContainer + .spacer'
        ];

        if ('mobilepreview' === this.contextType) {
            $(hideElList.join(', '))[b ? 'hide' : 'show']();
            if (!isTouchDevice) {
                if (b) {
                    $previewContainer.find('.backLabel').show().one('click.mobilepreviewback', function() {
                        diy.editor.mobilepreview.close();
                    });
                    $previewContainer.find('.viewLabel').hide();
                } else {
                    $previewContainer.find('.backLabel').hide().unbind('click.mobilepreviewback');
                    $previewContainer.find('.viewLabel').show();
                }
            }
        }
    },
    isMobilePreviewStateActive: function() {
        return $('#previewContainer .mobileView').hasClass('selected');
    },
    backAction: function() {
        window.location.href = this.element.find('.backLabel').attr('href');
    }
});

module.exports = Preview;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/preview.js
 ** module id = 844
 ** module chunks = 0 9 10
 **/